<template>
  <router-link
    :to="link"
    v-bind:class="getClasses(right, active, className)"
    v-if="link && !onClick"
  >
    <span class="icon-wrapper" v-if="right === false"
      ><DisplaySvg :name="icon"
    /></span>
    {{ text }}
    <span class="icon-wrapper" v-if="right === true"
      ><DisplaySvg :name="icon"
    /></span>
  </router-link>
  <div
    :onClick="onClick"
    v-bind:class="getClasses(right, active, className, loading)"
    v-if="onClick && !link"
  >
    <span class="icon-wrapper" v-if="right === false && !loading"
      ><DisplaySvg :name="icon"
    /></span>
    <span class="icon-loading" v-if="right === false && loading">
      <LoadingSpinner size="small" />
    </span>
    {{ text }}
    <span class="icon-wrapper" v-if="right === true && !loading"
      ><DisplaySvg :name="icon"
    /></span>
    <span class="icon-loading" v-if="right === true && loading">
      <LoadingSpinner size="small" />
    </span>
  </div>
</template>

<script>
import LoadingSpinner from "@/components/Shared/LoadingSpinner.vue";
import DisplaySvg from "@/components/Shared/DisplaySvg.vue";

export default {
  name: "LinkWithIcon",
  components: {
    DisplaySvg,
    LoadingSpinner,
  },
  props: {
    icon: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    right: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
    link: {
      type: String,
      required: false,
    },
    onClick: {
      type: Function,
      required: false,
    },
    className: {
      type: String,
      required: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getClasses(right, active, className, loading) {
      let classes = {
        "link-with-icon": true,
        "icon-on-left": right === false,
        "icon-on-right": right === true,
        "active-tab": active === true,
        disabled: loading,
      };
      if (className) {
        classes[className] = true;
      }
      return classes;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/_helpers.scss";
.link-with-icon {
  color: $navy;
  font-size: 13px;
  font-weight: 700;
  display: flex;
  align-items: center;
  text-decoration: none;
  text-transform: uppercase;
  margin: 5px 0 0 0;
  transition: $transition color, $transition background-color,
    opacity $transition;
  cursor: pointer;
  .icon-wrapper {
    width: 12px;
    position: relative;
    top: 1px;
  }
  &.icon-on-right {
    .icon-wrapper {
      margin-left: 5px;
    }
  }
  &.icon-on-left {
    .icon-wrapper {
      margin-right: 5px;
    }
  }

  &.active-tab {
    background-color: $white;
    border-radius: $border-radius-2;
    padding: 10px;
    border: 1px solid $medium-gray;
  }

  &.disabled {
    pointer-events: none;
    opacity: 0.7;
  }

  @include hover {
    color: $blue;
  }
}
</style>
